/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component,
  HostListener,
  OnInit,
  OnDestroy,
  AfterViewInit,
  ViewChild,
  ElementRef
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RankingsService } from '../../../services/rankings.service';
import {
  ReportConfig,
  REPORT_CONFIG,
  REGION_COUNTRY_MAPPING,
  DEFAULT_COUNTRY_PER_REGION_MAPPING
} from './REPORT_CONFIG';
import { RoundPipe } from '../../../pipes/round.pipe';
import { User } from '../../../models/User';
import { EventBusService } from '../../../services/EventBusService';
import { SIDENAV_ITEMS_PUBLISHER } from './SIDENAV_ITEMS_PUBLISHER';
import { SIDENAV_ITEMS_DEVICE } from './SIDENAV_ITEMS_DEVICE';
import { SIDENAV_ITEMS } from './SIDENAV_ITEMS';
import { SIDENAV_ITEMSMAPS } from './SIDENAV_ITEMSMAPS';
import { SideNavItem } from './models/sideNavItem';
import { SideNavItemsMap } from './models/sideNavItemsMap';
import { SummaryGrid } from './models/summaryGrid';
import { AppNavigationService } from '../../../services/app-navigation.service';
import { AuthService } from 'app/services/auth.service';
import { RankingsAnonFormService } from '../../../services/rankings-anon-form.service';
import { TrackingService } from 'app/services/tracking.service';
import {
  Breakpoint,
  MediaQueryService
} from '../../../services/media-query.service';
import { Observable } from 'rxjs';
import { MobileAppRanking } from './models/mobileAppRanking';
import { GroupType } from './types/group-type';
import { GridHeader } from './models/gridHeader';
import { MainFilterItem } from './models/mainFilterItem';
import { DropdownItem } from './models/dropdownItem';
import { MobileAppStiRanking } from './models/mobileAppStiRanking';

declare let jQuery: any;
declare let toastr: any;

@Component({
  selector: 'app-new-rankings',
  templateUrl: './rankings.component.html',
  styleUrls: ['./rankings.component.scss', './rankings-responsive.scss']
})
export class RankingsComponent implements OnInit, OnDestroy, AfterViewInit {
  currentConfig: ReportConfig;
  loading: boolean;
  loadingData: boolean;
  gridData: Array<MobileAppRanking>;
  showLoadMore: boolean;
  showLogin: boolean;
  showLoadingMore: boolean;
  noResult = false;
  sideNavItems: Array<SideNavItem>;
  roundPipe: RoundPipe = new RoundPipe();
  downloading: boolean;
  isPermitted: boolean;
  currentMapId: string;
  sideNavItemsMaps: Array<SideNavItemsMap>;
  selectedGroup: GroupType;
  lastUpdatedMonthLabel: string;
  isSummary: boolean;
  currentSideItemMap: SideNavItemsMap;
  summaryGrids: Array<SummaryGrid>;
  start: number;
  currentSideNavItem: SideNavItem;
  currentMainFilterItems: Array<MainFilterItem>;
  localStorageKey: string;
  tabletNavCollapsed = false;
  bp$: Observable<Breakpoint>;
  isDestroyed: boolean;

  allowUISort = false;
  allowSellerModal = false;
  allowSellerInsight = false;
  selectedSeller: MobileAppStiRanking;
  selectedDate: string;
  selectedPlatform: string;
  filterText = '';
  sortHeader: GridHeader;

  hasSubmittedAnonEmail: boolean;
  showAnonForm = true;
  hideScoreReports = ['high-risk-mfa'];

  get isFreemium(): boolean {
    return this._userService.isFreemium();
  }

  get isAnonymous(): boolean {
    return this._userService.isAnonymous();
  }

  @ViewChild('sideNav') sideNav: ElementRef;
  @ViewChild('sellerModal') sellerModal;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _mediaQueryService: MediaQueryService,
    private _appNavService: AppNavigationService,
    private _authService: AuthService,
    private _rankingsService: RankingsService,
    private _tracking: TrackingService,
    private _eventBus: EventBusService,
    private _rankingsAnonFormService: RankingsAnonFormService,
    public _userService: User
  ) {
    this.loading = false;
    this.loadingData = false;
    this.showLoadingMore = false;
    this.showLoadMore = false;
    this.showLogin = false;
    this._onSidebarClick = this._onSidebarClick.bind(this);
  }

  ngOnInit(): void {
    this._rankingsService.route = this._route;
    this.bp$ = this._mediaQueryService.activeBreakpoint$;
    this.isDestroyed = false;

    if (this._rankingsAnonFormService.isFormSubmitted()) {
      this.hasSubmittedAnonEmail = true;
      this.toggleAnonForm();
    }

    this.sideNavItems = JSON.parse(JSON.stringify(SIDENAV_ITEMS));
    this.sideNavItemsMaps = JSON.parse(JSON.stringify(SIDENAV_ITEMSMAPS));
    this.sideNavItemsMaps
      .map(map => map.sideNavItems)
      .forEach(sideNavItems => {
        sideNavItems.forEach(sideNavItem => (sideNavItem.active = false));
      });

    this.selectedGroup = this._route.snapshot.params['type'];
    const rankingtype = this._route.snapshot.params['rankingtype'];
    if (rankingtype) {
      const foundNavItemMap = this.sideNavItemsMaps.filter(
        map => map.id === rankingtype
      );
      if (foundNavItemMap && foundNavItemMap[0]) {
        this.showSummary(foundNavItemMap[0].id);
      } else {
        let sideNavItems = [];
        this.sideNavItemsMaps.forEach(map => {
          sideNavItems = sideNavItems.concat(map.sideNavItems);
        }); // SIDENAV_ITEMS.concat(SIDENAV_ITEMS_PUBLISHER).concat(SIDENAV_ITEMS_DEVICE);
        const foundNavItem = sideNavItems.filter(
          item => item.id === rankingtype
        );
        if (foundNavItem && foundNavItem[0]) {
          let sideNavItem = foundNavItem[0];
          let foundConfig = JSON.parse(
            JSON.stringify(
              REPORT_CONFIG.filter(config => config.key === sideNavItem.id)
            )
          );
          if (foundConfig && foundConfig[0]) {
            if (this._userService.hasPermissions(foundConfig[0].permissions)) {
              this.sideNavItemClick(sideNavItem, false, true);
            } else {
              let navIndex = 0;
              while (
                !this._userService.hasPermissions(foundConfig[0].permissions) &&
                navIndex < this.sideNavItems.length
              ) {
                sideNavItem = sideNavItems[navIndex];
                foundConfig = JSON.parse(
                  JSON.stringify(
                    REPORT_CONFIG.filter(
                      config => config.key === sideNavItem.id
                    )
                  )
                );
                navIndex++;
              }
              if (
                !this._userService.hasPermissions(foundConfig[0].permissions)
              ) {
                this._eventBus.showPopupEvent.emit(true);
              } else {
                this.sideNavItemClick(sideNavItem, false, true);
              }
            }
          }
        } else {
          const foundMap = this.sideNavItemsMaps.filter(
            map => map.id === rankingtype
          );
          if (foundMap && foundMap[0]) {
            const sideNavItem = foundMap[0].sideNavItems[0];
            this.sideNavItemClick(sideNavItem, false, true);
          }
        }
      }
    }

    setTimeout(() => {
      this._eventBus.showFeedback();
    }, 300);

    this._appNavService.setSelected('nav-rankings');
    this._appNavService.setIsMrtSearch(undefined);
  }

  ngAfterViewInit() {
    // console.log( this.sideNav.nativeElement );
  }

  ngOnDestroy() {
    this.sideNav.nativeElement.removeEventListener(
      'click',
      this._onSidebarClick
    );
    this.isDestroyed = true;

    // Ensure modal and backdrop are cleaned up when component is destroyed
    if (this.sellerModal) {
      jQuery(this.sellerModal.nativeElement).modal('dispose');
      jQuery('body').removeClass('modal-open');
      jQuery('.modal-backdrop').remove();
    }
  }

  private toggleAnonForm() {
    this.showAnonForm =
      !this.hasSubmittedAnonEmail &&
      this.isAnonymous &&
      this.hideScoreReports.includes(this.currentConfig?.key);
  }

  private toggleSideNav(toggle?: boolean) {
    // @hack bc sidenavitemclick is called in oninit
    if (!this.sideNav) {
      console.debug('sidenav is null', this.sideNav);
      return;
    }

    const classList = this.sideNav.nativeElement.classList;

    if (toggle == null) {
      toggle = !classList.contains('open');
    }

    if (toggle) {
      classList.add('open');
      console.debug('opening');
      this.sideNav.nativeElement.addEventListener(
        'click',
        this._onSidebarClick
      );
    } else {
      classList.remove('open');
      this.sideNav.nativeElement.removeEventListener(
        'click',
        this._onSidebarClick
      );
    }
  }

  _onSidebarTogglerClick(evt) {
    this.toggleSideNav(true);
    evt.stopPropagation();
  }

  _onSidebarClick(evt) {
    const el = this.sideNav.nativeElement;
    const rect = el.getBoundingClientRect();

    if (evt.clientX > rect.left && evt.clientX < rect.right) {
      return;
    }

    this.toggleSideNav(false);

    evt.preventDefault();
  }

  loadRankings(dontPassRouteParam?: boolean) {
    this.isPermitted = true;
    this.loading = true;
    this.loadingData = true;
    this.gridData = [];
    this.showLoadMore = false;
    this.start = 0;
    this.loadMonths(null, dontPassRouteParam ? null : this._route);
  }

  showSummary(mapId: string): void {
    if (!this.loading && !this.loadingData) {
      this.currentConfig = null;
      this.sideNavItemsMaps.forEach(foundMap => {
        if (foundMap.id === mapId) {
          foundMap.active = true;
          this.isSummary = true;
          this.currentSideItemMap = foundMap;
          this.currentSideItemMap.sideNavItems.forEach(sideNavItem => {
            sideNavItem.active = false;
          });
          this.currentMainFilterItems =
            this.currentSideItemMap.summaryMainFilterItems;
          this.summaryGrids = [];
          this.currentSideNavItem = null;
          this.currentSideItemMap.sideNavItems
            .filter(
              item =>
                !item.groups || item.groups.indexOf(this.selectedGroup) >= 0
            )
            .forEach(sideNavItem => {
              sideNavItem.active = false;
              const foundConfig = REPORT_CONFIG.filter(
                config => config.reportId === sideNavItem.reportId
              );
              if (foundConfig && foundConfig[0]) {
                const reportConfig = JSON.parse(JSON.stringify(foundConfig[0]));
                const columns: Array<GridHeader> = [];
                const gridHeaders = foundConfig[0].gridHeaders.filter(
                  header =>
                    !header.hidden &&
                    (!header.groups ||
                      header.groups.indexOf(this.selectedGroup) >= 0)
                );
                columns.push(gridHeaders[0]);
                columns.push(gridHeaders[1]);
                if (this.currentSideItemMap.id.indexOf('top-publisher') >= 0) {
                  columns.push(gridHeaders[2]);
                }
                reportConfig.mainFilterItems = [];
                foundConfig[0].mainFilterItems
                  .filter(
                    item =>
                      !item.groups ||
                      (item.groups &&
                        item.groups.length > 0 &&
                        item.groups.indexOf(this.selectedGroup) >= 0)
                  )
                  .forEach(mainFilterItem => {
                    // Check first for proper group, then filter only if not included in summary filters
                    const foundCurrentMainFilterItem =
                      this.currentMainFilterItems
                        .filter(
                          item =>
                            !item.groups ||
                            (item.groups &&
                              item.groups.length > 0 &&
                              item.groups.indexOf(this.selectedGroup) >= 0)
                        )
                        .filter(
                          currentItem => currentItem.key === mainFilterItem.key
                        );
                    if (
                      !foundCurrentMainFilterItem ||
                      !foundCurrentMainFilterItem[0]
                    ) {
                      reportConfig.mainFilterItems.push(mainFilterItem);
                    }
                  });

                this.summaryGrids.push({
                  sideNavItem: sideNavItem,
                  reportId: sideNavItem.reportId,
                  title: sideNavItem.title,
                  columns: columns,
                  mainFilterItems: reportConfig.mainFilterItems
                });
              }
            });
          this.loadSummaryGridData();
          if (!this.isDestroyed) {
            void this._router.navigate([
              '/rankings',
              this.selectedGroup,
              mapId
            ]);
          }
        } else {
          foundMap.active = false;
        }
      });
    }
  }

  loadSummaryGridData(): void {
    if (this.summaryGrids && this.summaryGrids.length > 0) {
      this.summaryGrids.forEach(grid => {
        // this.loadGridData(sideNavItem.reportId);
        const foundConfig = REPORT_CONFIG.filter(
          config => config.reportId === grid.reportId
        );
        if (foundConfig && foundConfig[0]) {
          this.start = 0;
          const reportConfig = foundConfig[0];
          this.loadMonths(reportConfig);
        }
      });
    }
  }

  sideNavItemClick(
    sideNavItem: SideNavItem,
    dontLoadRankings?: boolean,
    preserveQueryParams?: boolean,
    dontPassRouteParam?: boolean
  ) {
    const foundMaps = this.sideNavItemsMaps.filter(
      map => !map.groups || map.groups.indexOf(this.selectedGroup) >= 0
    );
    let matchedNavItem = null;
    if (foundMaps && foundMaps.length > 0) {
      foundMaps.forEach(sideMap => {
        const foundNavItem = sideMap.sideNavItems.filter(
          navItem =>
            !navItem.groups || navItem.groups.indexOf(this.selectedGroup) >= 0
        );

        const filteredNavItem = foundNavItem.filter(
          navItem => navItem.reportId === sideNavItem.reportId
        );
        if (filteredNavItem && filteredNavItem[0]) {
          matchedNavItem = filteredNavItem[0];
          this.currentSideItemMap = sideMap;
        }
      });

      if (!matchedNavItem) {
        this.currentSideItemMap = foundMaps[0];
        const foundSideNavItem = foundMaps[0].sideNavItems.filter(
          navItem =>
            !navItem.groups || navItem.groups.indexOf(this.selectedGroup) >= 0
        );

        if (foundSideNavItem && foundSideNavItem[0]) {
          sideNavItem = foundSideNavItem[0];
          sideNavItem.active = false;
        }
      }
    }
    if (!this.loading && !this.loadingData && !sideNavItem.active) {
      const foundConfig = REPORT_CONFIG.filter(
        config => config.key === sideNavItem.id
      ); //JSON.parse(JSON.stringify(REPORT_CONFIG.filter(config => config.key === sideNavItem.id)));
      if (foundConfig && foundConfig[0]) {
        if (this._userService.hasPermissions(foundConfig[0].permissions)) {
          this.currentSideNavItem = sideNavItem;
          this.isSummary = false;
          this.currentMapId = sideNavItem.mapId;
          this.currentConfig = foundConfig[0];
          this.toggleAnonForm();
          this.currentMainFilterItems =
            this.currentConfig.mainFilterItems.filter(
              filter =>
                !filter.groups ||
                filter.groups.length <= 0 ||
                filter.groups.includes(this.selectedGroup)
            );

          // Validate parameters for region and country
          this.currentMainFilterItems
            .filter(
              filter =>
                !filter.groups || filter.groups.indexOf(this.selectedGroup) >= 0
            )
            .forEach(
              (mainFilter, index) =>
                (mainFilter.routeParam = `param${index + 1}`)
            );

          // Prepare MainFilterItems based on RouteParams
          this.currentMainFilterItems.forEach(mainFilterItem => {
            let paramValue =
              this._rankingsService.getFilterParam(mainFilterItem);

            if (
              mainFilterItem.label === 'Date' ||
              mainFilterItem.label === 'Month'
            ) {
              mainFilterItem.options = [];
              if (paramValue) {
                mainFilterItem.selected = {
                  label: this._rankingsService.getMonthOptionLabel(
                    this.currentConfig?.reportId,
                    paramValue
                  ),
                  value: paramValue
                };
              } else {
                mainFilterItem.selected = null;
              }
            } else {
              if (mainFilterItem.label === 'Region') {
                const validRegion = REGION_COUNTRY_MAPPING.some(
                  item => item.region === paramValue
                );
                if (!validRegion) {
                  paramValue = 'NA';
                }
              } else if (mainFilterItem.label === 'Country') {
                const regionFilter = this.currentMainFilterItems.find(
                  mainFilterItem => mainFilterItem.label === 'Region'
                );
                const regionParam = regionFilter
                  ? regionFilter.selected.value
                  : undefined;
                if (
                  regionParam !== 'NA' &&
                  this.getRegion(paramValue) !== regionParam
                ) {
                  paramValue = 'GLOBAL';
                }
              }
              mainFilterItem.selected = {
                label: paramValue,
                value: paramValue
              };

              if (
                mainFilterItem.label === 'Country' &&
                paramValue === 'GLOBAL'
              ) {
                mainFilterItem.selected.label = 'All Countries';
              }
            }
          });

          if (!dontLoadRankings) {
            this.loading = true;
            this.loadingData = true;
            this.loadRankings(dontPassRouteParam);

            const props = {
              id: sideNavItem.id,
              rankingsUrl: window.location.href
            };
            this._tracking.eventTrack(
              'clicked_rankingslink_from_sidenav',
              props
            );

            const sideNavItems = SIDENAV_ITEMS.concat(
              SIDENAV_ITEMS_PUBLISHER
            ).concat(SIDENAV_ITEMS_DEVICE);
            sideNavItems.forEach(navItem => {
              navItem.active = sideNavItem.id === navItem.id;
            });
          }
          const extras: any = {};
          if (!preserveQueryParams) {
            extras.queryParams = {};
          } else {
            extras.queryParamsHandling = 'merge';
          }
        } else {
          this._eventBus.showPopupEvent.emit(true);
          this.loading = false;
          this.loadingData = false;
        }
      }
    }

    setTimeout(() => {
      jQuery(document).scrollTop(0);
    }, 500);

    this._rankingsService.setPageDocumentMeta(this.currentConfig.key, {
      type: this.selectedGroup
    });

    this.toggleSideNav(false);
  }

  loadMonths(reportConfig?: ReportConfig, _route?: ActivatedRoute) {
    this.gridData = [];
    this.start = 0;
    let mainFilterItems =
      this.isSummary && reportConfig
        ? reportConfig.mainFilterItems
        : this.currentConfig.mainFilterItems;
    mainFilterItems = mainFilterItems.filter(
      filter => !filter.groups || filter.groups.indexOf(this.selectedGroup) >= 0
    );
    mainFilterItems.forEach(
      (mainFilter, index) => (mainFilter.routeParam = `param${index + 1}`)
    );
    const monthFilterItem = mainFilterItems.filter(
      filter => filter.key === 'date'
    )[0];
    if (monthFilterItem && monthFilterItem.options.length <= 0) {
      this.loading = true;
      void this._rankingsService
        .loadMonthOptions(
          reportConfig,
          this.currentConfig,
          mainFilterItems,
          monthFilterItem,
          this.selectedGroup,
          this.isSummary,
          _route
        )
        .then(() => {
          this.loading = false;
          this.lastUpdatedMonthLabel = monthFilterItem.options[0].label;
          this.loadGridData(reportConfig);
        });
    } else {
      this.loading = false;
      this.loadGridData(reportConfig);
    }
  }

  loadMore() {
    this.showLoadingMore = true;
    this.loadGridData();
  }

  rankingGroupSelect(group: GroupType): void {
    if (!this.loading && !this.loadingData) {
      if (this.selectedGroup !== group) {
        this.selectedGroup = group;
        if (this.isSummary) {
          this.showSummary(this.currentSideItemMap.id);
        } else {
          this.currentSideNavItem.active = false;
          this.sideNavItemClick(this.currentSideNavItem, false, false, true);
        }
      }
    }
  }

  removeSellerParam(): void {
    void this._router.navigate([], {
      relativeTo: this._route,
      queryParams: { s: null },
      queryParamsHandling: 'merge'
    });
  }

  findSellerByTokenizedName(
    tokenizedSellerName: string
  ): MobileAppStiRanking | undefined {
    return this.gridData.find(
      seller =>
        this.tokenizeName((seller as MobileAppStiRanking).sellerName) ===
        tokenizedSellerName
    ) as MobileAppStiRanking | undefined;
  }

  private tokenizeName(name: string): string {
    return name
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
  }

  openSellerModalFromTokenizedName(tokenizedSellerName: string) {
    const seller = this.findSellerByTokenizedName(tokenizedSellerName);
    if (seller) {
      this.loadSellerModal(seller);
    } else {
      console.warn(`Seller "${tokenizedSellerName}" not found in the data.`);
      this.removeSellerParam();
    }
  }

  onRowClick(dataItem: MobileAppStiRanking) {
    if (this.allowSellerInsight) {
      this.navigateToSeller(dataItem);
    } else if (this.allowSellerModal) {
      this.loadSellerModal(dataItem);
    }
  }

  navigateToSeller(dataItem: MobileAppStiRanking) {
    const foundFilter = this._rankingsService.getFilterSelected(
      this.currentMainFilterItems,
      'key',
      'platformName'
    );
    const foundRFilter = this._rankingsService.getFilterSelected(
      this.currentMainFilterItems,
      'label',
      'Region'
    );
    const foundCFilter = this._rankingsService.getFilterSelected(
      this.currentMainFilterItems,
      'label',
      'Country'
    );
    const foundDFilter = this._rankingsService.getFilterSelected(
      this.currentMainFilterItems,
      'key',
      'date'
    );

    const routeParams = [
      '/insight',
      'sellers',
      dataItem?.sellerId,
      this.selectedGroup,
      foundRFilter.value,
      foundFilter?.value ? foundFilter.value.toLowerCase() : ''
    ];

    void this._router.navigate(routeParams, {
      queryParams: {
        country: foundCFilter.value,
        date: foundDFilter.value
      }
    });
  }

  loadSellerModal(dataItem: MobileAppStiRanking) {
    if (!this.sellerModal) return;

    this.selectedSeller = dataItem;

    if (!jQuery(this.sellerModal.nativeElement).hasClass('show')) {
      jQuery(this.sellerModal.nativeElement).modal({
        backdrop: true,
        keyboard: true,
        focus: true,
        show: true
      });

      jQuery(this.sellerModal.nativeElement).on('hidden.bs.modal', () => {
        this.closeModal();
      });
    }

    this.setSellerModalRoute(dataItem);
  }

  setSellerModalRoute(dataItem: MobileAppStiRanking) {
    void this._router.navigate([], {
      relativeTo: this._route,
      queryParams: { s: this.tokenizeName(dataItem.sellerName) },
      queryParamsHandling: 'merge'
    });
  }

  closeModal(): void {
    jQuery(this.sellerModal.nativeElement).modal('hide');
    jQuery('body').removeClass('modal-open');
    jQuery('.modal-backdrop').remove();

    jQuery(this.sellerModal.nativeElement).off('hidden.bs.modal');

    this.selectedSeller = null;
    this.removeSellerParam();
  }

  loadGridData(reportConfig?: ReportConfig) {
    this.loadingData = true;
    this.showLoadMore = false;
    this.filterText = '';
    const currentMainFilterItems = this.currentConfig.mainFilterItems.filter(
      filter => !filter.groups || filter.groups.includes(this.selectedGroup)
    );
    const group = this.selectedGroup;
    let mainFilterItems = [];
    if (this.isSummary && reportConfig) {
      const foundGrid = this.summaryGrids.filter(
        grid => grid.reportId === reportConfig.reportId
      );
      if (foundGrid && foundGrid[0]) {
        const grid = foundGrid[0];
        grid.loading = true;
        mainFilterItems = this.currentSideItemMap.summaryMainFilterItems.concat(
          grid.mainFilterItems
        );
      }
    } else if (this.currentConfig) {
      mainFilterItems = currentMainFilterItems;
    }

    const addParams = new Map();
    const routeParams = [
      '/rankings',
      this.selectedGroup,
      this.currentSideNavItem.id
    ];
    mainFilterItems = mainFilterItems.filter(
      item => !item.groups || item.groups.indexOf(this.selectedGroup) >= 0
    );

    const foundFilter = this._rankingsService.getFilterSelected(
      mainFilterItems,
      'key',
      'platformName'
    );
    const foundRFilter = this._rankingsService.getFilterSelected(
      mainFilterItems,
      'label',
      'Region'
    );
    const foundCFilter = this._rankingsService.getFilterSelected(
      mainFilterItems,
      'label',
      'Country'
    );
    const foundDFilter = this._rankingsService.getFilterSelected(
      mainFilterItems,
      'key',
      'date'
    );

    this.selectedDate = foundDFilter.value;
    this.selectedPlatform = foundFilter.value;
    this.allowUISort =
      this.selectedDate >= '20240601' &&
      this.currentConfig.key === 'seller-trust-index';
    this.allowSellerModal = this.allowUISort;
    this.allowSellerInsight =
      this.allowUISort && this._userService.sellerEnabled();

    // Set initial state of the addParams and routeParams
    mainFilterItems.forEach(mainFilterItem => {
      if (
        mainFilterItem.selected ||
        mainFilterItem.label == 'Country' ||
        mainFilterItem.label == 'Region'
      ) {
        let value =
          mainFilterItem?.selected?.value || mainFilterItem.options[0]?.value;
        if (mainFilterItem.label == 'Region' && foundRFilter.value) {
          value = foundRFilter.value;
        } else if (mainFilterItem.label == 'Country' && foundCFilter.value) {
          value = foundCFilter.value;
        }
        addParams.set(
          mainFilterItem.apiKey ? mainFilterItem.apiKey : mainFilterItem.key,
          encodeURIComponent(value)
        );
        routeParams.push(value);
      }
    });

    const propMap: any = {
      type: this.selectedGroup,
      platformName: foundFilter.value || '',
      countryCode: foundCFilter.label || '',
      date: foundDFilter.label || ''
    };
    this._rankingsService.setPageDocumentMeta(this.currentConfig.key, propMap);

    if (this.currentConfig.key === 'seller-trust-index') {
      // show/hide headers according to group and date
      const shownHeaders = [
        'marketShareScore',
        'spoOptimizationScore',
        'scoVerificationScore',
        'bundleIntegrityScore'
      ];

      let hiddenHeaders = [];
      if (this.selectedGroup == 'domain') {
        hiddenHeaders = ['reachScore', 'adsTxtScore', 'viewabilityScore'];
      } else if (this.selectedGroup == 'app') {
        hiddenHeaders = ['reachScore', 'transparencyScore', 'locationScore'];
      } else if (this.selectedGroup == 'ctv') {
        hiddenHeaders = [
          'householdScore',
          'channelShareScore',
          'ssaiScore',
          'spoofingScore',
          'sideloadedScore'
        ];
      }

      const hidden = foundDFilter.value >= '20240601';
      this.currentConfig.gridHeaders.forEach(header => {
        if (shownHeaders.indexOf(header.key) > -1) {
          header.hidden = !hidden;
        } else if (hiddenHeaders.indexOf(header.key) > -1) {
          header.hidden = hidden;
        } else if (header.key == 'delistedImpressionsScore') {
          header.hidden = foundDFilter.value < '20250301';
        }
      });

      // Override state of addParams and routeParams if needed
      let regionCode = 'GLOBAL';
      if (this.selectedGroup !== 'domain' && foundDFilter.value < '20240601') {
        // For CTV STI, and App STI prior to Q2 2024
        addParams.set('countryCode', regionCode);
        routeParams[3] = regionCode;
        routeParams[4] = 'GLOBAL';
      } else {
        // For Website STI prior to Q2 2024
        // For CTV, App, and Website from Q2 2024 onwards

        // Show/Hide GridColumn
        const maskingScore = this.currentConfig.gridHeaders.find(
          header => header.key === 'maskingScore'
        );
        const mfaRiskScore = this.currentConfig.gridHeaders.find(
          header => header.key === 'mfaRiskScore'
        );
        const websiteCount = this.currentConfig.gridHeaders.find(
          header => header.key === 'websiteCount'
        );
        maskingScore.hidden = true;
        mfaRiskScore.hidden = false;
        websiteCount.hidden = true;

        regionCode = addParams.get('countryCode');
        if (foundDFilter.value <= '20230901') {
          // version 1
          maskingScore.hidden = false;
          mfaRiskScore.hidden = true;
          regionCode = foundRFilter.value;
          if (['NON-US', 'US'].indexOf(regionCode) == -1) {
            regionCode = 'US';
          }
          addParams.set('countryCode', regionCode);
          routeParams[3] = regionCode;
          routeParams[4] = 'GLOBAL';
        } else if (foundDFilter.value < '20240601') {
          // version 2
          regionCode = foundRFilter.value;
          if (
            ['GLOBAL', 'NA', 'EMEA', 'LATAM', 'APAC'].indexOf(regionCode) == -1
          ) {
            regionCode = 'GLOBAL';
          }
          addParams.set('countryCode', regionCode);
          routeParams[3] = regionCode;
          routeParams[4] = 'GLOBAL';
        } else {
          // latest version
          websiteCount.hidden = false;

          regionCode = this.getValidRegion(foundRFilter.value);
          const countryCode = this.getValidCountry(
            regionCode,
            foundCFilter.value
          );

          if (countryCode && countryCode != 'GLOBAL') {
            addParams.set('countryCode', countryCode);
          } else {
            if (['NA', 'EMEA', 'LATAM', 'APAC'].indexOf(regionCode) == -1) {
              regionCode = 'NA';
            }
            addParams.set('countryCode', regionCode);
          }

          if (this.selectedGroup === 'ctv') {
            routeParams[4] = regionCode;
            routeParams[5] = countryCode || 'NA';
          } else {
            routeParams[3] = regionCode;
            routeParams[4] = countryCode || 'NA';
          }
        }
      }
    } else {
      if (addParams.get('date') < '20210801') {
        if (this.currentConfig.key === 'publisher-trust-index') {
          addParams.set('countryCode', foundRFilter.value);
        }
      } else {
        if (
          foundCFilter.value !== undefined &&
          foundCFilter.value !== 'GLOBAL'
        ) {
          const countryFilter = mainFilterItems.find(
            filter => filter.key === 'countryCode'
          );
          addParams.set(
            countryFilter?.apiKey ? countryFilter?.apiKey : countryFilter?.key,
            foundCFilter.value
          );
          if (this.currentConfig?.key !== 'publisher-coppa') {
            addParams.set('isRegion', false);
          }
        } else if (foundRFilter.value) {
          addParams.set('countryCode', foundRFilter.value);
          addParams.set('isRegion', true);
        }
      }
    }

    const sortColumns = this.currentConfig.gridHeaders
      .filter(header => header?.sort?.length > 0 && header.sortColumnKey)
      .map(
        header =>
          `${header.sortColumnKey} ${
            header.sort === 'sort-asc' ? 'asc' : 'desc'
          } ${
            header?.addSortColumnKeys
              ? ',' + header?.addSortColumnKeys.join(',')
              : ''
          }`
      );
    if (sortColumns.length > 0) {
      addParams.set('sortBy', sortColumns[0]);
    }

    const additionalQueryString =
      this._rankingsService.mapToUrlParam(addParams);

    let limit = 100;
    this.showLoadMore = false;

    if (this.currentConfig.key === 'seller-trust-index') {
      limit = 2000; // retrieve all so we can apply sorting in the UI
    } else if (this.isAnonymous) {
      this.showLogin = true;
    } else if (!this.gridData || this.gridData.length <= 0) {
      limit = 200;
    } else {
      limit = 1000;
    }

    if (this.isSummary) {
      limit = 10;
    }
    const reportId =
      this.isSummary && reportConfig
        ? reportConfig.reportId
        : this.currentConfig.reportId;
    const props = {
      reportId: reportId,
      group: group,
      queryParams: additionalQueryString,
      rankingsUrl: window.location.href
    };
    this._tracking.eventTrack('rankings_page_view', props);
    void this._rankingsService
      .getRankingsData(
        reportId,
        group,
        this.start,
        limit,
        additionalQueryString
      )
      .then(response => {
        if (response && response['docs']) {
          if (this.isSummary) {
            const foundSummaryGrid = this.summaryGrids.filter(
              grid => grid.reportId === reportId
            );
            if (foundSummaryGrid && foundSummaryGrid[0]) {
              foundSummaryGrid[0].data = response['docs'];
              foundSummaryGrid[0].loading = false;
            }
          } else {
            this.gridData =
              this.start === 0
                ? response['docs']
                : this.gridData.concat(response['docs']);
            this.showLoadingMore = false;
            this.start = this.gridData.length;
            this.noResult = this.gridData.length === 0;
            setTimeout(() => {
              jQuery('img.sicon').on('error', function () {
                jQuery(this).css('opacity', '0');
              });
            }, 100);

            this._route.queryParams.subscribe(params => {
              if (params['s']) {
                const tokenizedSellerName = params['s'];
                this.openSellerModalFromTokenizedName(tokenizedSellerName);
              }
            });

            if (this.noResult && this.selectedDate >= '20240601') {
              toastr.error(
                'Data is not available for the selected region/country. Now showing United States of North America.',
                { timeOut: 5000 }
              );

              if (this.selectedGroup === 'ctv') {
                routeParams[4] = 'NA';
                routeParams[5] = 'US';
              } else {
                routeParams[3] = 'NA';
                routeParams[4] = 'US';
              }

              void this._router.navigate(routeParams);
            }
          }
        }
        setTimeout(() => {
          this.loadingData = false;
        }, 300);
      });

    if (!this.isDestroyed) {
      void this._router.navigate(routeParams, {
        relativeTo: this._route,
        queryParams: this._route.snapshot.queryParams,
        queryParamsHandling: 'merge'
      });
    }
  }

  getRegion(country: string): string {
    let region = 'GLOBAL';
    if (country !== undefined) {
      for (const regionMap of REGION_COUNTRY_MAPPING) {
        if (regionMap.countries && regionMap.countries.indexOf(country) > -1) {
          region = regionMap.region;
          break;
        }
      }
    }
    return region;
  }

  getValidRegion(region: string): string {
    if (['APAC', 'EMEA', 'LATAM', 'NA'].indexOf(region) > -1) {
      return region;
    }
    return 'NA';
  }

  getValidCountry(region: string, country: string): string {
    if (country !== undefined && country != 'GLOBAL') {
      for (const regionMap of REGION_COUNTRY_MAPPING) {
        if (
          regionMap.region == region &&
          regionMap.countries &&
          regionMap.countries.indexOf(country) > -1
        ) {
          return country;
        }
      }
    }

    return (DEFAULT_COUNTRY_PER_REGION_MAPPING[region] as string) || 'US';
  }

  scheduleDemo() {
    window.open('https://info.pixalate.com/scheduledemo', '_blank');
  }

  summaryGridSelectMainFilter(
    grid: SummaryGrid,
    selectedMainFilterItem: MainFilterItem,
    option: DropdownItem
  ) {
    if (
      selectedMainFilterItem.selected.value &&
      option.value &&
      selectedMainFilterItem.selected.value !== option.value
    ) {
      selectedMainFilterItem.selected = option;
      const foundConfig = REPORT_CONFIG.filter(
        config => config.reportId === grid.reportId
      );
      if (foundConfig && foundConfig[0]) {
        const reportConfig = foundConfig[0];
        grid.mainFilterItems.forEach(mainFilterItem => {
          if (
            mainFilterItem &&
            mainFilterItem.dependencies &&
            mainFilterItem.dependencies.length > 0
          ) {
            const foundDepdendency = mainFilterItem.dependencies.filter(
              dependency =>
                dependency.key === selectedMainFilterItem.key &&
                (!dependency.group || dependency.group === this.selectedGroup)
            );
            if (foundDepdendency && foundDepdendency[0]) {
              void this._rankingsService.loadOptions(
                mainFilterItem,
                reportConfig,
                this.currentConfig,
                this.selectedGroup,
                this.isSummary
              );
            }
          }
        });

        this.loadGridData(reportConfig);
      }
    }
  }

  selectMainFilter(
    selectedMainFilterItem: MainFilterItem,
    option: DropdownItem
  ) {
    if (
      selectedMainFilterItem.selected.value &&
      option.value &&
      selectedMainFilterItem.selected.value !== option.value
    ) {
      selectedMainFilterItem.selected = option;

      const promises = [];
      // Reload dependency Facets based on dependency key and group
      this.currentMainFilterItems.forEach(mainFilterItem => {
        if (
          mainFilterItem.dependencies &&
          mainFilterItem.dependencies.length > 0
        ) {
          const foundDepdendency = mainFilterItem.dependencies.some(
            dependency =>
              (dependency.key === selectedMainFilterItem.key ||
                dependency.label === selectedMainFilterItem.label) &&
              (!dependency.group || dependency.group === this.selectedGroup)
          );
          if (foundDepdendency) {
            promises.push(
              this._rankingsService.loadOptions(
                mainFilterItem,
                null,
                this.currentConfig,
                this.selectedGroup,
                this.isSummary
              )
            );
          }
        }
      });

      this.start = 0;
      this.gridData = [];
      if (this.isSummary) {
        this.loadSummaryGridData();
      } else {
        void Promise.all(promises).then(() => this.loadGridData());
      }
    }
  }

  toggleSort(selectedGridHeader: GridHeader) {
    if (this.allowUISort) {
      // allow sort by UI only
      selectedGridHeader.sort =
        selectedGridHeader.sort == 'sort-asc' ? 'sort-desc' : 'sort-asc';
      this.sortHeader = selectedGridHeader;
    } else if (
      selectedGridHeader.sortColumnKey &&
      !this.loadingData &&
      !this.isFreemium
    ) {
      this.currentConfig.gridHeaders.forEach(gridHeader => {
        if (gridHeader.key === selectedGridHeader.key) {
          const sort = gridHeader.sort;
          if (sort === '' || sort === 'sort-desc') {
            gridHeader.sort = 'sort-asc';
          } else if (sort === 'sort-asc') {
            gridHeader.sort = 'sort-desc';
          }
        } else {
          gridHeader.sort = '';
        }
      });
      this.start = 0;
      this.loadGridData();
    }
  }

  handleAnonFormSubmit() {
    this.hasSubmittedAnonEmail = true;
    setTimeout(() => {
      this.toggleAnonForm();
    }, 2000);
  }

  login() {
    this._authService.login();
  }

  searchHandler(searchText: string) {
    this.filterText = searchText;
  }

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    if (
      jQuery('.rankings-main-content .right-content') &&
      jQuery('.rankings-main-content .right-content').offset() &&
      jQuery('.right-content.rankings .grid-data') &&
      jQuery('.right-content.rankings .grid-data').offset()
    ) {
      const offsetTop = jQuery('.rankings-main-content .right-content').offset()
        .top;
      const scrollTop = jQuery(window).scrollTop();
      if (scrollTop < offsetTop) {
        jQuery('.rankings-main-content').removeClass('sticky-nav');
      } else {
        jQuery('.rankings-main-content').addClass('sticky-nav');
      }

      const mobilediff =
        jQuery(window).height() +
        (jQuery(window).scrollTop() -
          (jQuery('.rankings-main-content .right-content').offset().top +
            jQuery('.rankings-main-content .right-content').outerHeight()));
      if (mobilediff > 0) {
        jQuery('.rankings-main-content .side-navigation').css(
          'margin-bottom',
          mobilediff + 'px'
        );
      } else {
        jQuery('.rankings-main-content .side-navigation').css(
          'margin-bottom',
          '0px'
        );
      }

      const iscrollTop = jQuery(document).scrollTop();
      const ioffsetTop = jQuery('.right-content.rankings .grid-data').offset()
        .top;
      const iheaderHeight = jQuery(
        '.right-content.rankings .grid-header'
      ).outerHeight();

      if (iscrollTop >= ioffsetTop - iheaderHeight) {
        jQuery('.right-content.rankings').addClass('sticky');
      } else {
        jQuery('.right-content.rankings').removeClass('sticky');
      }
    }
  }
}
